export default __webpack_public_path__ + "static/media/img-ln-5-invest-and-trade.ac761659.png";